import { render, staticRenderFns } from "./Borrowers.vue?vue&type=template&id=f178d2e6&"
import script from "./Borrowers.vue?vue&type=script&lang=js&"
export * from "./Borrowers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports